import React, { useEffect } from "react";
import styled from "styled-components";
import { Input, Table } from "antd";
import { useTranslation } from "react-i18next";
import { formatPrice } from "../../../../../functions/formatters";
import { CURRENCY } from "../../../../../constants/DeliveryConstants";

const ProductSalesDetailsTable = ({ processedProducts }) => {
  const { t } = useTranslation();
  const [filteredProducts, setFilteredProducts] = React.useState(processedProducts);

  useEffect(() => {
    setFilteredProducts(processedProducts);
  }, [processedProducts]);

  const handleSearch = (value) => {
    if (value === "") setFilteredProducts(processedProducts);
    const filtered = processedProducts.filter(
      (product) =>
        product.name.toLowerCase().includes(value.toLowerCase()) ||
        product.code?.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredProducts(filtered);
  };

  return (
    <Card>
      <CardTitle>{t("product_sales_details")}</CardTitle>
      <Input
        style={{ width: "fit-content", marginBottom: 6 }}
        placeholder={t("search")}
        onChange={(e) => handleSearch(e.target.value)}
      />
      <div style={{ overflowX: "auto" }}>
        <Table
          columns={[
            {
              title: t("product"),
              dataIndex: "name",
              key: "name",
              render: (text, record) => <span>{text}</span>,
            },
            {
              title: t("amount_sold"),
              dataIndex: "totalQuantity",
              key: "totalQuantity",
              sorter: (a, b) => a.totalQuantity - b.totalQuantity,
              render: (text, record) => (
                <span>
                  {text} {t("pieces").toLowerCase()}
                </span>
              ),
            },
            {
              title: t("total_revenue"),
              dataIndex: "totalValue",
              key: "totalValue",
              sorter: (a, b) => a.totalValue - b.totalValue,
              render: (text, record) => <span>{CURRENCY + formatPrice(text)}</span>,
            },
            {
              title: t("avg_price"),
              dataIndex: "totalValue",
              key: "totalValue",
              render: (text, record) => <span>{CURRENCY + formatPrice(text / record.totalQuantity)}</span>,
            },
            {
              title: t("percentage_of_total"),
              dataIndex: "totalValue",
              key: "totalValue",
              render: (text, record) => (
                <span>{((text / processedProducts.reduce((sum, p) => sum + p.totalValue, 0)) * 100).toFixed(1)}%</span>
              ),
            },
          ]}
          dataSource={filteredProducts}
        />
      </div>
    </Card>
  );
};

const Card = styled.div`
  background-color: white;
  border-radius: 0.5rem;
  box-shadow:
    0 1px 3px 0 rgba(0, 0, 0, 0.1),
    0 1px 2px 0 rgba(0, 0, 0, 0.06);
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  margin-bottom: 1rem;
`;

export default ProductSalesDetailsTable;
